export const convertRatingStringToNumber = (rating) => {
  switch (rating) {
    case 'A':
      return 10;
    case 'A-':
      return 9;
    case 'B':
      return 8;
    case 'B-':
      return 7;
    case 'C':
      return 6;
    case 'C-':
      return 5;
    case 'D':
      return 4;
    case 'D-':
      return 3;
    case 'E':
      return 2;
    case 'E-':
      return 1;
    default:
      return 0;
  }
};

export const isOdd = num => num % 2;

export const MAX_RATING_NUMBER = 10;
